import { Avatar, Box, Button, Text } from '@chakra-ui/react'
import { FC, useEffect, useRef } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { GAAction, sendGA4Event } from '~/analytics/ga'
import { getPersonOfTheDay } from '~/utils/teams'

interface MinWorkspacesSectionProp {
	linkToMarketplace: string
	locationsLength: number
}

const MinWorkspacesSection: FC<MinWorkspacesSectionProp> = ({
	linkToMarketplace,
	locationsLength,
}) => {
	const { t } = useTranslation()
	const manager = getPersonOfTheDay()
	const ref = useRef<HTMLDivElement | null>(null)
	useEffect(() => {
		if (!ref.current) {
			return
		}
		const top =
			ref.current.getBoundingClientRect().top +
			document.documentElement.scrollTop -
			60
		window.scrollTo({ top, left: 0, behavior: 'smooth' })
	}, [])
	return (
		<Box
			display="grid"
			gridTemplate="min-content min-content / min-content 1fr"
			gridGap={5}
			ref={ref}
		>
			<Avatar
				name={manager.name}
				src={manager.img}
				gridColumn="1 / 2"
				gridRow="1 / 2"
			/>
			<Text
				w="fit-content"
				fontSize="sm"
				backgroundColor="green.500"
				px="30px"
				py="15px"
				borderRadius={{ base: '3xl', md: 'full' }}
				gridColumn="2 / 3"
				gridRow="1 / 2"
			>
				<Trans
					i18nKey="Jag hittade {{locations_length}} kontorshotell som passar era krav. För team på 1-2 personer rekommenderar jag att ni jämför och bokar visningar direkt via marknadsplatsen."
					defaults="Jag hittade <bold>{{locations_length}}</bold> kontorshotell som passar era krav. För team på 1-2 personer rekommenderar jag att ni jämför och bokar visningar direkt via marknadsplatsen."
					values={{ locations_length: locationsLength }}
					components={{
						bold: <b />,
					}}
				/>
			</Text>
			<Button
				as={Link}
				to={linkToMarketplace}
				onClick={() => {
					GAAction({
						category: 'office_help',
						action: 'step_completed',
						label: 'to_marketplace',
					})
					sendGA4Event('small_kontorshjalpen', {
						step: 'click_marketplace',
					})
				}}
				w={{ base: '100%', md: '50%' }}
				borderRadius="full"
				gridColumn="2 / 3"
				gridRow="2 / 3"
			>
				{t('Till marknadsplatsen')}
			</Button>
		</Box>
	)
}

export default MinWorkspacesSection
